module.exports = __webpack_public_path__ + "static/fonts/ElegantIcons.d72ad3f.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/elegant_font/fonts/ElegantIcons.eot
// module id = 7N96
// module chunks = 25